module.exports = __webpack_public_path__ + "static/img/khxd.84fd3dc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/khxd.jpg
// module id = 0wEQ
// module chunks = 1